import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/features/auth/store';
import { stripeConnectApi } from '../api';
import { paymentsKeys } from '../queryKeys';
import type { ConnectStatusResponse } from '../types';

export function useConnectStatus() {
  const token = useAuthStore((s) => s.token);

  return useQuery<ConnectStatusResponse>({
    queryKey: paymentsKeys.connectStatus,
    queryFn: () => stripeConnectApi.getConnectStatus(token),
    enabled: !!token,
    staleTime: 30 * 1000,
  });
}
